module.exports = __webpack_public_path__ + "static/media/test-image-2.51c65bb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/layers/images/test-image-2.jpg
// module id = 490
// module chunks = 0